import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const comic_filter_faq_data = [
    {
        question: "What is the Comic Filter, and how does it work?",
        answer: "The Comic Filter is an AI-powered tool that transforms photos into comic-book–style art. It automatically adds bold outlines, dramatic shadows, halftone textures, and vivid colors to recreate the authentic look of classic and modern comics.",
    },
    {
        question: "Do I need graphic design skills to use the Comic Filter?",
        answer: "No experience needed! The Comic Filter does all the hard work for you. Simply upload a photo, and the AI instantly turns it into a dynamic comic-style portrait or scene — no Photoshop or drawing required.",
    },
    {
        question: "What kinds of photos look best with the Comic Filter?",
        answer: "Portraits and action shots look amazing, but any image can be turned into a comic panel — from pets and vehicles to cityscapes or group photos. The filter adapts to any subject with striking results.",
    },
    {
        question: "Are my uploaded photos safe and private?",
        answer: "Yes, your photos are safe. Patternful.ai automatically deletes your uploaded images after processing, ensuring complete privacy and ownership of your generated comic art.",
    },
];

const comic_filter_use_cases = [
    {
        title: "Comic-Style Avatars",
        description:
            "Transform your selfies into powerful comic-style characters. Perfect for profile pictures, digital personas, or creative social media posts that stand out.",
        image: "/images/image-filters/comic-filter-5.webp",
    },
    {
        title: "Graphic Stories & Posters",
        description:
            "Create custom comic panels or storyboards for digital art projects, event posters, or storytelling. Great for artists, writers, and marketers who want an illustrated edge.",
        image: "/images/image-filters/comic-filter-6.webp",
    },
    {
        title: "Merch & Prints",
        description:
            "Use your comic-style portraits for stickers, t-shirts, or prints. Turn your AI-generated artwork into collectible and creative gifts.",
        image: "/images/image-filters/comic-filter-7.webp",
    },
];

const ComicFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/comic-filter-1.webp"}
                title={"Turn Photos into Comic-Book Art Instantly"}
                description={
                    "Step into the world of bold lines and vibrant colors. The Comic Filter transforms any image into comic-book–style art using AI. It adds halftone textures, dramatic shading, and color blocking that capture the energy of printed comics — all in one click."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/comic-filter-2.webp"}
                title={"Create Comic Heroes from Everyday Selfies"}
                description={
                    "See yourself as the hero of your own story! The Comic Filter brings out your strong features and stylizes them with bold contour lines and dynamic lighting. Whether you want a vintage comic look or a modern graphic-novel style, the AI delivers stunning results."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/comic-filter-3.webp"}
                title={"Add Comic Flair to Any Scene or Object"}
                description={
                    "Not just for portraits — use the Comic Filter on cars, pets, or cityscapes to give them that illustrated pop-art vibe. It’s perfect for creating digital covers, creative collages, or marketing visuals with impact."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/comic-filter-4.webp"}
                title={"Design Your Own Comic Panels and Stories"}
                description={
                    "Combine your AI-generated comic images into sequences or layouts for storytelling. With its expressive tones and consistent art style, the Comic Filter helps you build narratives and visual worlds effortlessly."
                }
            />
            <UseCases
                data={comic_filter_use_cases}
                title={"Creative and Pretty Comic Filters for Everyone"}
            />
            <SellFaq data={comic_filter_faq_data} />
        </PBox>
    );
};

export default ComicFilter;
